import React from "react";
import {
  Grid,
  TextField,
  Switch,
  FormControlLabel,
  Typography,
  Box,
  useTheme,
} from "@mui/material";

interface Props {
  config: any;
  onChange: (field: string, value: any) => void;
}

const XciraForm: React.FC<Props> = ({ config, onChange }) => {
  const theme = useTheme();
  const red = theme.palette.status.accent; // UMS red accent

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderLeft: `3px solid ${red}`,
        borderRadius: 2,
        p: 2,
        mt: 1,
        boxShadow: "0 0 6px rgba(0,0,0,0.3)",
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          mb: 2,
          fontWeight: 600,
          color: red,
          letterSpacing: 0.3,
        }}
      >
        Xcira Configuration
      </Typography>

      <Grid container spacing={2}>
        {/* Dealer ID */}
        <Grid item xs={6}>
          <TextField
            label="Dealer ID"
            fullWidth
            value={config.dealerID || ""}
            onChange={(e) => onChange("dealerID", e.target.value)}
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
            }}
          />
        </Grid>

        {/* Enabled Switch */}
        <Grid item xs={6}>
          <FormControlLabel
            control={
              <Switch
                checked={config.enabled ?? false}
                onChange={(e) => onChange("enabled", e.target.checked)}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": { color: red },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: red,
                  },
                }}
              />
            }
            label={<Typography sx={{ fontWeight: 500 }}>Enabled</Typography>}
          />
        </Grid>

        {/* Syndication Image Groups */}
        <Grid item xs={12}>
          <TextField
            label="Syndication Image Groups"
            fullWidth
            value={config.syndicationImageGroups || ""}
            onChange={(e) =>
              onChange("syndicationImageGroups", e.target.value)
            }
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default XciraForm;
